'use client';
import { getT, langToApiCode } from './i18n';
import { useLangCtx, LANG_COOKIE } from './i18n-context';

/**
 * Storage key kept for backward-compat (LanguageSwitcher + legacy readers).
 * The active language now lives in React context (seeded from the `logixa_lang`
 * cookie at SSR), so useT/useApiLang resolve identically on server and client
 * — no more hydration mismatch. See i18n-context.tsx.
 */
export const LANG_STORAGE_KEY = LANG_COOKIE;

/** Translate function for the active UI language. */
export function useT() {
  return getT(useLangCtx());
}

/**
 * Active 2-letter API language code (de/en/ru/ua/md/kz/cz/pl/bg) — use when
 * passing `?lang=` to a public API endpoint that returns localized data.
 */
export function useApiLang(): string {
  return langToApiCode(useLangCtx());
}
